import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { CommonDataPassService } from './common-data-pass.service';

import { environment } from '../../../environments/environment';
import { isPlatformServer } from '@angular/common';

export const httpInterceptor: HttpInterceptorFn = (request, next):Observable<any> => {
  let commonDataPass = inject(CommonDataPassService)
  const platformId = inject(PLATFORM_ID);
  
  // Add origin header here
  if(isPlatformServer(platformId)){
    request = request.clone({
      setHeaders: {
        'Origin': environment.origin
      }
    });
  }

return next(request).pipe(

  
  catchError((err: HttpErrorResponse) => {
    if (err instanceof HttpErrorResponse) {
      if (err.status === 401) {
        commonDataPass.openCustomToastr({isOpen:true,message:'Unauthorized',type:'danger',timeout:3000})
      } else if (err.status === 400) {
        commonDataPass.openCustomToastr({isOpen:true,message:err.error ? JSON.stringify(err.error.error) :'Bad Input',type:'danger',timeout:3000})
        console.log('Bad Input');
      }else if (err.status === 403) {
        commonDataPass.openCustomToastr({isOpen:true,message:err.error ? JSON.stringify(err.error) :'Forbidden',type:'danger',timeout:3000})
        console.log('Forbidden');
      } else if (err.status === 404) {
        commonDataPass.openCustomToastr({isOpen:true,message:err.error.error ?err.error.error :'Not Found',type:'danger',timeout:3000})
        console.log('Not Found');
      } else if (err.status === 500) {
        commonDataPass.openCustomToastr({isOpen:true,message:err.error.error ?err.error.error :'Internal server Error',type:'danger',timeout:3000})
        console.log('Internal server Error');
      }  else if (err.status === 0) {
        console.log('No Internet Connection');
      }
    }
    return throwError(err);
  })
);
};
